import Space from "@sentrei/common/models/Space";
import serializeSpace from "@sentrei/common/serializers/Space";
import {analytics, db} from "@sentrei/common/utils/firebase";
import {generateRandomId, generateSlug} from "@sentrei/common/utils/generate";

const spaceConverter: firebase.firestore.FirestoreDataConverter<Space.Get> = {
  toFirestore(data: Space.Get) {
    return data;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<Space.Response>,
  ): Space.Get {
    return serializeSpace(snapshot);
  },
};

export const validateSpace = async (id: string): Promise<boolean> => {
  const space = await db.doc(`spaces/${id}`).get();
  return !space.exists;
};

export const createSpace = async (space: Space.Create): Promise<string> => {
  let id = generateSlug(space.name);
  const isValidSlug = await validateSpace(id);

  if (!isValidSlug) {
    id = `${id}-${generateRandomId()}`;
  }

  analytics().logEvent("space_create");
  await db.doc(`spaces/${id}`).set(space);
  return id;
};

export const getSpace = async (id: string): Promise<Space.Get> => {
  const snap = await db.doc(`spaces/${id}`).withConverter(spaceConverter).get();
  const data = snap.data();
  if (!data) {
    throw new Error("Space is not found");
  }
  return data;
};
